var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMapMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 12.4299C11.7235 12.4299 13.1204 11.0331 13.1204 9.30994C13.1204 7.58681 11.7235 6.18994 10.0004 6.18994C8.27724 6.18994 6.88037 7.58681 6.88037 9.30994C6.88037 11.0331 8.27724 12.4299 10.0004 12.4299Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6202 7.49C3.5902 -1.17 16.4202 -1.16 18.3802 7.5C19.5302 12.58 16.3702 16.88 13.6002 19.54C11.5902 21.48 8.4102 21.48 6.3902 19.54C3.6302 16.88 0.470197 12.57 1.6202 7.49Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapMark);
export default __webpack_public_path__ + "static/media/icon_map_mark.ac65a273dac8cf81f811aa01a1383788.svg";
export { ForwardRef as ReactComponent };